export const REDUCER_NAME = 'detail'




// WEBPACK FOOTER //
// ./src/modules/prospect/state/detail/const.js